import * as React from "react"
import FsLightbox from "fslightbox-react"
import ImageReview0 from "./ImageReviews/ImageReview0"
import ImageReview1 from "./ImageReviews/ImageReview1"
import ImageReview2 from "./ImageReviews/ImageReview2"
import ImageReview3 from "./ImageReviews/ImageReview3"
import ImageReview4 from "./ImageReviews/ImageReview4"
import ImageReview5 from "./ImageReviews/ImageReview5"
import PlayButton from "../images/playButton.inline.svg"
import Quote from "../images/quote.inline.svg"

const HomeReviews = ({ reviewRef, isReviewsPlay }) => {
  const [showVideo, setShowVideo] = React.useState(false)

  return (
    <div id="rewiews" className="quote-section" ref={reviewRef}>
      <div className="container">
        <div className="title-wrap">
          <div className="title">О Даше, тренировках и марафонах</div>
          <h2>Видео отзывы</h2>
        </div>
        <div className="w-layout-grid quote-grid">
          <div className="quote-block">
            <div className="quote-wrap">
              <button
                className="button-play"
                onClick={() => setShowVideo(!showVideo)}
              >
                <ImageReview0 />
                <PlayButton className="icon-play" />
                <span className="icon-play-span button w-button">
                  Смотреть видео
                </span>
              </button>
              <Quote className="quote" />
              <p className="author-name">Евгения</p>
              <div className="detail">Участница марафона</div>
            </div>
          </div>
          <div className="quote-block">
            <div className="quote-wrap">
              <button
                className="button-play"
                onClick={() => setShowVideo(!showVideo)}
              >
                <ImageReview1 />
                <PlayButton className="icon-play" />
                <span className="icon-play-span button w-button">
                  Смотреть видео
                </span>
              </button>
              <Quote className="quote" />
              <p className="author-name">Лидия</p>
              <div className="detail">Личные тренировки</div>
            </div>
          </div>
          <div className="quote-block">
            <div className="quote-wrap">
              <button
                className="button-play"
                onClick={() => setShowVideo(!showVideo)}
              >
                <ImageReview2 />
                {<PlayButton className="icon-play" />}
                <span className="icon-play-span button w-button">
                  Смотреть видео
                </span>
              </button>
              <Quote className="quote" />
              <p className="author-name">Ольга</p>
              <div className="detail">Участница марафона</div>
            </div>
          </div>
          <div className="quote-block">
            <div className="quote-wrap">
              <button
                className="button-play"
                onClick={() => setShowVideo(!showVideo)}
              >
                <ImageReview3 />
                <PlayButton className="icon-play" />
                <span className="icon-play-span button w-button">
                  Смотреть видео
                </span>
              </button>
              <Quote className="quote" />
              <p className="author-name">Светлана</p>
              <div className="detail">Участница марафона</div>
            </div>
          </div>
          <div className="quote-block">
            <div className="quote-wrap">
              <button
                className="button-play"
                onClick={() => setShowVideo(!showVideo)}
              >
                <ImageReview4 />
                <PlayButton className="icon-play" />
                <span className="icon-play-span button w-button">
                  Смотреть видео
                </span>
              </button>
              <Quote className="quote" />
              <p className="author-name">Екатерина</p>
              <div className="detail">Личные тренировки</div>
            </div>
          </div>
          <div className="quote-block">
            <div className="quote-wrap">
              <button
                className="button-play"
                onClick={() => setShowVideo(!showVideo)}
              >
                <ImageReview5 />
                <PlayButton className="icon-play" />
                <span className="icon-play-span button w-button">
                  Смотреть видео
                </span>
              </button>
              <Quote className="quote" />
              <p className="author-name">Маргарита</p>
              <div className="detail">Участница марафона</div>
            </div>
          </div>
          <FsLightbox
            toggler={showVideo}
            sources={[
              "https://www.youtube.com/watch?v=zFsoaaqWAis",
              "https://www.youtube.com/watch?v=8tzOHWnz_uw",
              "https://www.youtube.com/watch?v=jSlSeSHgQdg",
              "https://www.youtube.com/watch?v=EjTuCjHHixI",
              "https://www.youtube.com/watch?v=YlYJNmYlses",
              "https://www.youtube.com/watch?v=-bY5yNRYySg",
            ]}
          />
        </div>
      </div>
    </div>
  )
}

export default HomeReviews
